import { SvgIcon } from "@mui/material";
import { useTheme } from "@mui/material/styles";

import { getEnvironmentVariable } from "../../../global/environmentVariables";
const COMPANY_FLAG = getEnvironmentVariable("COMPANY_FLAG");

export function FaLocationDot(props) {
  let { color, sx, ...rest } = props;
  const theme = useTheme();
  if (COMPANY_FLAG === "bcp" && theme?.palette?.mode === "light")
    color = "#172b4d";

  var colorArray =
    color && color.trim().includes("#")
      ? [color]
      : color
        ? color.split(".")
        : undefined;
  return (
    <SvgIcon
      sx={{
        "& path": {
          color: !colorArray?.length
            ? theme?.palette?.text?.primary
            : theme.palette[colorArray[0]]?.[colorArray[1] || "main"] ||
              color ||
              "inherit",
        },
        ...sx,
      }}
      {...rest}
    >
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 384 512">
        <path d="M192 512s192-208 192-320C384 86 298 0 192 0S0 86 0 192C0 304 192 512 192 512zm0-256c-35.3 0-64-28.7-64-64s28.7-64 64-64s64 28.7 64 64s-28.7 64-64 64z" />
      </svg>
    </SvgIcon>
  );
}

export function FaLink(props) {
  let { color, sx, ...rest } = props;
  const theme = useTheme();
  if (COMPANY_FLAG === "bcp" && theme?.palette?.mode === "light")
    color = "#172b4d";

  var colorArray =
    color && color.trim().includes("#")
      ? [color]
      : color
        ? color.split(".")
        : undefined;
  return (
    <SvgIcon
      sx={{
        "& path": {
          color: !colorArray?.length
            ? theme?.palette?.text?.primary
            : theme.palette[colorArray[0]]?.[colorArray[1] || "main"] ||
              color ||
              "inherit",
        },
        ...sx,
      }}
      {...rest}
    >
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 640 512">
        <path d="M580.2 267.3c56.2-56.2 56.2-147.4 0-203.6S432.8 7.4 376.6 63.7L365.3 75l45.3 45.3 11.3-11.3c31.2-31.2 81.9-31.2 113.1 0s31.2 81.9 0 113.1L421.8 335.2c-31.2 31.2-81.9 31.2-113.1 0c-25.6-25.6-30.3-64.3-13.8-94.6c1.8-3.4 3.9-6.7 6.3-9.8l-51.2-38.4c-4.3 5.7-8.1 11.6-11.4 17.8c-29.5 54.6-21.3 124.2 24.9 170.3c56.2 56.2 147.4 56.2 203.6 0L580.2 267.3zM59.8 244.7c-56.2 56.2-56.2 147.4 0 203.6s147.4 56.2 203.6 0L274.7 437l-45.3-45.3-11.3 11.3c-31.2 31.2-81.9 31.2-113.1 0s-31.2-81.9 0-113.1L218.2 176.8c31.2-31.2 81.9-31.2 113.1 0c25.6 25.6 30.3 64.3 13.8 94.6c-1.8 3.4-3.9 6.7-6.3 9.8l51.2 38.4c4.3-5.7 8.1-11.6 11.4-17.8c29.5-54.6 21.3-124.2-24.9-170.3c-56.2-56.2-147.4-56.2-203.6 0L59.8 244.7z" />
      </svg>
    </SvgIcon>
  );
}

export function FaClipboardList(props) {
  let { color, sx, ...rest } = props;
  const theme = useTheme();
  if (COMPANY_FLAG === "bcp" && theme?.palette?.mode === "light")
    color = "#172b4d";

  var colorArray =
    color && color.trim().includes("#")
      ? [color]
      : color
        ? color.split(".")
        : undefined;
  return (
    <SvgIcon
      sx={{
        "& path": {
          color: !colorArray?.length
            ? theme?.palette?.text?.primary
            : theme.palette[colorArray[0]]?.[colorArray[1] || "main"] ||
              color ||
              "inherit",
        },
        ...sx,
      }}
      {...rest}
    >
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 384 512">
        <path d="M101.5 64C114.6 26.7 150.2 0 192 0s77.4 26.7 90.5 64H384V512H0V64H101.5zM224 96c0-17.7-14.3-32-32-32s-32 14.3-32 32s14.3 32 32 32s32-14.3 32-32zM160 352v32h16H304h16V352H304 176 160zM96 392c13.3 0 24-10.7 24-24s-10.7-24-24-24s-24 10.7-24 24s10.7 24 24 24zm64-136v32h16H304h16V256H304 176 160zM96 296c13.3 0 24-10.7 24-24s-10.7-24-24-24s-24 10.7-24 24s10.7 24 24 24z" />
      </svg>
    </SvgIcon>
  );
}

export function FaCalendarDays(props) {
  let { color, sx, ...rest } = props;
  const theme = useTheme();
  if (COMPANY_FLAG === "bcp" && theme?.palette?.mode === "light")
    color = "#172b4d";

  var colorArray =
    color && color.trim().includes("#")
      ? [color]
      : color
        ? color.split(".")
        : undefined;
  return (
    <SvgIcon
      sx={{
        "& path": {
          color: !colorArray?.length
            ? theme?.palette?.text?.primary
            : theme.palette[colorArray[0]]?.[colorArray[1] || "main"] ||
              color ||
              "inherit",
        },
        ...sx,
      }}
      {...rest}
    >
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512">
        <path d="M160 0V64H288V0h64V64h96v96H0V64H96V0h64zM0 192H448V512H0V192zM64 320h64V256H64v64zm128-64v64h64V256H192zm192 64V256H320v64h64zM64 448h64V384H64v64zm192-64H192v64h64V384zm64 64h64V384H320v64z" />
      </svg>
    </SvgIcon>
  );
}

export function FaRankingStar(props) {
  let { color, sx, ...rest } = props;
  const theme = useTheme();
  if (COMPANY_FLAG === "bcp" && theme?.palette?.mode === "light")
    color = "#172b4d";

  var colorArray =
    color && color.trim().includes("#")
      ? [color]
      : color
        ? color.split(".")
        : undefined;
  return (
    <SvgIcon
      sx={{
        "& path": {
          color: !colorArray?.length
            ? theme?.palette?.text?.primary
            : theme.palette[colorArray[0]]?.[colorArray[1] || "main"] ||
              color ||
              "inherit",
        },
        ...sx,
      }}
      {...rest}
    >
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 640 512">
        <path d="M351.8 62.3L320 0 288.2 62.3l-69 11 49.4 49.5L257.7 192 320 160.3 382.3 192l-10.9-69.1 49.4-49.5-69-11zM416 256H224V512H416V256zM192 320H0V512H192V320zm256 64V512H640V384H448z" />
      </svg>
    </SvgIcon>
  );
}

export function FaSwords(props) {
  let { color, sx, ...rest } = props;
  const theme = useTheme();
  if (COMPANY_FLAG === "bcp" && theme?.palette?.mode === "light")
    color = "#172b4d";

  var colorArray =
    color && color.trim().includes("#")
      ? [color]
      : color
        ? color.split(".")
        : undefined;
  return (
    <SvgIcon
      sx={{
        "& path": {
          color: !colorArray?.length
            ? theme?.palette?.text?.primary
            : theme.palette[colorArray[0]]?.[colorArray[1] || "main"] ||
              color ||
              "inherit",
        },
        ...sx,
      }}
      {...rest}
    >
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
        <path d="M16 96L0 0 96 16 393.4 313.4l-80 80L16 96zM408 456l-72 24-32-32L448 304l32 32-24 72 56 56-48 48-56-56zM96 336l57.4-57.4 80 80L176 416l32 32-32 32-72-24L48 512 0 464l56-56L32 336l32-32 32 32zM496 96L358.6 233.4l-80-80L416 16 512 0 496 96z" />
      </svg>
    </SvgIcon>
  );
}

export function FaBook(props) {
  let { color, sx, ...rest } = props;
  const theme = useTheme();
  if (COMPANY_FLAG === "bcp" && theme?.palette?.mode === "light")
    color = "#172b4d";

  var colorArray =
    color && color.trim().includes("#")
      ? [color]
      : color
        ? color.split(".")
        : undefined;
  return (
    <SvgIcon
      sx={{
        "& path": {
          color: !colorArray?.length
            ? theme?.palette?.text?.primary
            : theme.palette[colorArray[0]]?.[colorArray[1] || "main"] ||
              color ||
              "inherit",
        },
        ...sx,
      }}
      {...rest}
    >
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512">
        <path d="M96 0C43 0 0 43 0 96V416c0 53 43 96 96 96H384h32 32V448H416V384h32V0H416 384 96zm0 384H352v64H96c-17.7 0-32-14.3-32-32s14.3-32 32-32zm32-256H352v32H128V128zm224 64v32H128V192H352z" />
      </svg>
    </SvgIcon>
  );
}

export function FaHouse(props) {
  let { color, sx, ...rest } = props;
  const theme = useTheme();
  if (COMPANY_FLAG === "bcp" && theme?.palette?.mode === "light")
    color = "#172b4d";

  var colorArray =
    color && color.trim().includes("#")
      ? [color]
      : color
        ? color.split(".")
        : undefined;
  return (
    <SvgIcon
      sx={{
        "& path": {
          color: !colorArray?.length
            ? theme?.palette?.text?.primary
            : theme.palette[colorArray[0]]?.[colorArray[1] || "main"] ||
              color ||
              "inherit",
        },
        ...sx,
      }}
      {...rest}
    >
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 576 512">
        <path d="M511.8 287.6H576V240L288.4 0 0 240v47.6H64.1V512H224V352H352V512H512.8l-1-224.4z" />
      </svg>
    </SvgIcon>
  );
}

export function FaGear(props) {
  let { color, sx, ...rest } = props;
  const theme = useTheme();
  if (COMPANY_FLAG === "bcp" && theme?.palette?.mode === "light")
    color = "#172b4d";

  var colorArray =
    color && color.trim().includes("#")
      ? [color]
      : color
        ? color.split(".")
        : undefined;
  return (
    <SvgIcon
      sx={{
        "& path": {
          color: !colorArray?.length
            ? theme?.palette?.text?.primary
            : theme.palette[colorArray[0]]?.[colorArray[1] || "main"] ||
              color ||
              "inherit",
        },
        ...sx,
      }}
      {...rest}
    >
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
        <path d="M200 0H312l17.2 78.4c15.8 6.5 30.6 15.1 44 25.4l76.5-24.4 56 97-59.4 54.1c1.1 8.3 1.7 16.8 1.7 25.4s-.6 17.1-1.7 25.4l59.4 54.1-56 97-76.5-24.4c-13.4 10.3-28.2 18.9-44 25.4L312 512H200l-17.2-78.4c-15.8-6.5-30.6-15.1-44-25.4L62.3 432.5l-56-97 59.4-54.1C64.6 273.1 64 264.6 64 256s.6-17.1 1.7-25.4L6.3 176.5l56-97 76.5 24.4c13.4-10.3 28.2-18.9 44-25.4L200 0zm56 336c44.2 0 80-35.8 80-80s-35.8-80-80-80s-80 35.8-80 80s35.8 80 80 80z" />
      </svg>
    </SvgIcon>
  );
}

export function FaQuestion(props) {
  let { color, sx, ...rest } = props;
  const theme = useTheme();
  if (COMPANY_FLAG === "bcp" && theme?.palette?.mode === "light")
    color = "#172b4d";

  var colorArray =
    color && color.trim().includes("#")
      ? [color]
      : color
        ? color.split(".")
        : undefined;
  return (
    <SvgIcon
      sx={{
        "& path": {
          color: !colorArray?.length
            ? theme?.palette?.text?.primary
            : theme.palette[colorArray[0]]?.[colorArray[1] || "main"] ||
              color ||
              "inherit",
        },
        ...sx,
      }}
      {...rest}
    >
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 320 512">
        <path d="M96 96c-17.7 0-32 14.3-32 32v32H0V128C0 75 43 32 96 32h97c70.1 0 127 56.9 127 127c0 52.4-32.2 99.4-81 118.4l-63 24.5V320v32H112V320 280 258.1l20.4-7.9 83.4-32.4C240 208.3 256 185 256 159c0-34.8-28.2-63-63-63H96zm80 320v64H112V416h64z" />
      </svg>
    </SvgIcon>
  );
}

export function FaCircleCheck(props) {
  let { color, sx, ...rest } = props;
  const theme = useTheme();
  if (COMPANY_FLAG === "bcp" && theme?.palette?.mode === "light")
    color = "#172b4d";

  var colorArray =
    color && color.trim().includes("#")
      ? [color]
      : color
        ? color.split(".")
        : undefined;
  return (
    <SvgIcon
      sx={{
        "& path": {
          color: !colorArray?.length
            ? theme?.palette?.text?.primary
            : theme.palette[colorArray[0]]?.[colorArray[1] || "main"] ||
              color ||
              "inherit",
        },
        ...sx,
      }}
      {...rest}
    >
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
        <path d="M256 512c141.4 0 256-114.6 256-256S397.4 0 256 0S0 114.6 0 256S114.6 512 256 512zM369 209L241 337l-17 17-17-17-64-64-17-17L160 222.1l17 17 47 47L335 175l17-17L385.9 192l-17 17z" />
      </svg>
    </SvgIcon>
  );
}
